type EventProps = Record<string, any>;

let amplitudeReady = false;
let cachedUserId: string | null = null;
const DEVICE_ID_KEY = 'my_saved_device_id';

function isBot(): boolean {
  if (typeof navigator === 'undefined') return true;

  const ua = navigator.userAgent.toLowerCase();

  return (
    ua.includes('bot') ||
    ua.includes('crawl') ||
    ua.includes('spider') ||
    ua.includes('preview') ||
    ua.includes('python') ||
    ua.includes('node') ||
    ua.includes('curl')
  );
}

export const initAnalytics = () => {
  if (isBot() || typeof window === 'undefined') return;

  const amp = window.amplitude;
  if (!amp || !amp.init) return;

  const storedDeviceId = localStorage.getItem(DEVICE_ID_KEY);

  amp.init('9ee52f7475574a04b4ad1947ef68d13a', {
    deviceId: storedDeviceId || undefined,
    fetchRemoteConfig: true,
    autocapture: true,
  });

  amp.getDeviceId?.() && localStorage.setItem(DEVICE_ID_KEY, amp.getDeviceId());

  if (cachedUserId) {
    amp.setUserId(cachedUserId);
  }

  amplitudeReady = true;
};

export const setUser = (userId: string, properties?: Record<string, any>) => {
  cachedUserId = userId;

  if (typeof window === 'undefined') return;

  window.amplitude?.setUserId?.(userId);
  if (properties) {
    window.amplitude?.setUserProperties?.(properties);
  }

  window.gtag?.('set', { user_id: userId });
};

export const resetUser = () => {
  if (typeof window === 'undefined') return;

  window.amplitude?.setUserId?.(null);
  window.amplitude?.setUserProperties?.({});
  window.gtag?.('set', { user_id: null });
};

export const trackEvent = (eventName: string, props: EventProps = {}) => {
  if (typeof window === 'undefined') return;

  // Amplitude
  if (amplitudeReady && window.amplitude?.track) {
    window.amplitude.track(eventName, props);
  }

  // Google Analytics
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, props);
  }
};
